/**
 * @author xyguo
 * @description 新增/编辑
 * @Date  2021/7/20
 */
import React from "react";
import { connect } from "dva";
import { component_tool, framework_tool, utils_tool } from '../../../../tool';
import OrgRemoteEvaluationDetailForm from './orgRemoteEvaluationDetailForm'
import moment from "moment";
import { formatAuth } from '@/utils/commonUtils';
let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool


class OrgRemoteEvaluationDetail extends WizContainer {
  componentName = 'orgRemoteEvaluationDetail';

  constructor(props) {
    super(props);
    const { history } = this.props;
    let initialValue = {};
    let positionState = 1;
    let cardTitle = '新增';
    if (history.location && history.location.pathname === '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        positionState = initialValue.state;
        Session.set('orgRemoteEvaluationDetailUpd', initialValue)
      } else {
        initialValue = Session.get('orgRemoteEvaluationDetailUpd') || {};
      }
      cardTitle = '编辑'
      // if (initialValue.startDate) {
      //   initialValue.startDate = moment(initialValue.startDate, 'YYYY-MM-DD HH:mm:ss')
      // }
      // if (initialValue.endDate) {
      //   initialValue.endDate = moment(initialValue.endDate, 'YYYY-MM-DD HH:mm:ss')
      // }
    }
    this.state = {
      cardTitle: cardTitle,
      formKey: 'liveForm',
      formInitialValue:{},
      checkDateInfo : undefined,
      authInfo : undefined,
    }
    this.initialValue = initialValue;
  }

  _componentDidMount() {
    if (this.initialValue.id) {
      this.doAction({
        path: 'orgRemoteAuthDetail/selectOneById',
        payload: {
          key: "selectOneById",
          apiParams: {
            id: this.initialValue.id
          }
        }
      });
    }
  }

  /**校验对应时间段是否有直播资源 */
  checkMeetingDate(startDate, endDate,meetingNo,type) {
    this.setState({
      checkDateInfo : undefined
    })
    this.doAction({
      path: 'interactLive/checkMeetingDate',
      payload: {
        key: 'interactLive@checkMeetingDate',
        apiParams: {
          startDate,
          endDate,
          meetingNo,
          type
        }
      }
    });
  }

  _getAuthStudent(remoteAuthId,orgId){
    if(remoteAuthId && orgId){
      this.doAction({
        path: 'remoteAuth/getRemoteAuthConfigPersonInfoList',
        payload: {
          key: 'getRemoteAuthConfigPersonInfoList',
          apiParams: {
            remoteAuthId,orgId
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    saveOrgRemoteAuthDetail: this._saveOrgRemoteAuthDetailOver.bind(this),
    selectOneById: this._selectOneByIdOver.bind(this),
    checkMeetingDate: this._checkMeetingDateOver.bind(this),
    getAuthStudent : this._getAuthStudentOver.bind(this),
  }

  _getAuthStudentOver(nextProps, nextState) {
    if (nextProps.getAuthStudent.code == 1) {
      nextState.authInfo = nextProps.getAuthStudent.data
      if(this.OrgRemoteEvaluationDetailForm){
        this.OrgRemoteEvaluationDetailForm.setAuthValue(nextState.authInfo) //调用子组件的方法
      }
     // wizNotice.success('保存成功');
    } else {
      wizNotice.error('提交失败：' + nextProps.getAuthStudent.msg);
    }
    return true;
  }

  _saveOrgRemoteAuthDetailOver(nextProps, nextState) {
    if (nextProps.saveOrgRemoteAuthDetail.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/remoteAuth/orgRemoteEvaluationDetailList');
    } else {
      wizNotice.error('提交失败：' + nextProps.saveOrgRemoteAuthDetail.msg);
    }
    return true;
  }

  _selectOneByIdOver(nextProps, nextState) {
    if (nextProps.selectOneById.code == 1) {
      this.initialValue = nextProps.selectOneById.data;
      //数据拼接
      if(this.initialValue.lectureId && this.initialValue.lectureName){
        this.initialValue.personInfo = [{key:'1',personId:this.initialValue.lectureId, fullName:this.initialValue.lectureName ,id:this.initialValue.lectureId}]
      }
      if(this.initialValue.liveCategoryId && this.initialValue.liveCategoryName){
        this.initialValue.categoryInfo = [{key:this.initialValue.liveCategoryId,title:this.initialValue.liveCategoryName}]
      }
      if(this.initialValue.remoteAuthId && this.initialValue.remoteAuthName){
        this.initialValue.remoteAuthInfo = [{id:this.initialValue.remoteAuthId,name:this.initialValue.remoteAuthName}]
      }
      if(this.initialValue.orgId && this.initialValue.orgName){
        this.initialValue.orgInfo = [{id:this.initialValue.orgId,name:this.initialValue.orgName}]
      }
      if(this.initialValue.personInfoList){
        let personInfoListNew = [];
        this.initialValue.personInfoList.forEach(element => {
          personInfoListNew.push({...element,id:element.personId,key:element.personId})
        });
        this.initialValue.personInfoList = personInfoListNew
      }
      
      if (this.initialValue.startDate) {
        this.initialValue.startDate = moment(this.initialValue.startDate, 'YYYY-MM-DD HH:mm:ss')
      }
      if (this.initialValue.endDate) {
        this.initialValue.endDate = moment(this.initialValue.endDate, 'YYYY-MM-DD HH:mm:ss')
      }
      nextState.formInitialValue = Object.assign({},this.initialValue)
      nextState.formKey = 'liveForm' + new Date().getTime()
    }
    return true;
  }

  _checkMeetingDateOver(nextProps, nextState) {
    if (nextProps.checkMeetingDate.code == 1) {
      nextState.checkDateInfo = nextProps.checkMeetingDate.data
    } else {

    }
    return true;
  }

  

  /**
   * 保存/更新
   * @param values
   * @private
   */
  _save(values) {
    const { history } = this.props;
    let apiPath = "orgRemoteAuthDetail/add";
    if (this.initialValue.id) {
      apiPath = "orgRemoteAuthDetail/update";
    }
    if (values && values['img'] && values['img'].length) {
      values.img = values.img[0].fileId;
    } else {
      values.img = "";
    }
    if (values['remoteDate'] && values['remoteDate'].length && values['remoteDate'].length>0) {
      let remoteDate = values['remoteDate']
      values.startDate = remoteDate[0].format('YYYY-MM-DD HH:mm:ss');
      values.endDate = remoteDate[1].format('YYYY-MM-DD HH:mm:ss');
    }
    if(values.liveCategoryId){
      values.liveCategoryId = values.liveCategoryId[0];
    }
    if (values['authCmd']) {
      values.personIdList = values['authCmd']
      if (values.personIdList && values.personIdList instanceof Array && values.personIdList.length>24){
        wizNotice.error('提交失败：总人数限制24人，请确认后重试');
        return;
      }
    }
    if(this.initialValue && this.initialValue.ownerId){
      values.ownerId = this.initialValue.ownerId
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: "saveOrgRemoteAuthDetail",
        apiParams: {
          ...values,
          id: this.initialValue.id,
          oldStartDate : this.initialValue.startDate ? this.initialValue.startDate.format('YYYY-MM-DD HH:mm:ss') : ""
        }
      }
    });
  }


  _render() {
    const { interactLiveLoading,orgRemoteAuthDetailLoading } = this.props;
    let { cardTitle, formInitialValue,checkDateInfo,authInfo } = this.state;
    return <WizCard>
      <WizSpin tip={'加载中'} spinning={interactLiveLoading || orgRemoteAuthDetailLoading}>

        <OrgRemoteEvaluationDetailForm className={'form-inline'} key={this.state.formKey} initialValue={this.initialValue} authInfo={authInfo}
          onSubmit={this._save.bind(this)} checkMeetingDate={this.checkMeetingDate.bind(this)} checkDateInfo={checkDateInfo}
          getAuthStudent={this._getAuthStudent.bind(this)}
          onRef={c=>this.OrgRemoteEvaluationDetailForm=c}
          />
          
      </WizSpin>
    </WizCard>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { interactLive,remoteAuth,orgRemoteAuthDetail,remoteAssessment } = state;
  const saveOrgRemoteAuthDetail = modelUtils.getModelEntity(orgRemoteAuthDetail, "saveOrgRemoteAuthDetail");
  const selectOneById = modelUtils.getModelEntity(orgRemoteAuthDetail, "selectOneById");
  const checkMeetingDate = modelUtils.getModelEntity(interactLive, "interactLive@checkMeetingDate");
  const getAuthStudent = modelUtils.getModelEntity(remoteAuth, "getRemoteAuthConfigPersonInfoList");
  const load = modelUtils.getLoadingState(state, ['interactLive','orgRemoteAuthDetail']);

  
  return {
    saveOrgRemoteAuthDetail: saveOrgRemoteAuthDetail,
    selectOneById,
    checkMeetingDate,
    getAuthStudent,
    ...load
  }
};

export default connect(mapStateToProps)(OrgRemoteEvaluationDetail);
